/**
 * Header: mega menu, sticky observer, search popover.
 * Desktop (xl+). Mobile drawer handled in mobile-menu.js.
 */
(function ($) {
    'use strict';

    $(function () {
        var $header = $('.mnhq-header');
        var $triggers = $header.find('.mnhq-mega-trigger[aria-haspopup="true"]');
        var $items = $header.find('.mnhq-mega-item');
        var $searchToggle = $header.find('.mnhq-header__search-toggle');
        var $searchPopover = $('#mnhq-search-popover');

        function closeAllMega() {
            $triggers.attr('aria-expanded', 'false');
            $items.removeClass('is-open');
        }

        function openMega($item) {
            closeAllMega();
            $item.addClass('is-open').find('.mnhq-mega-trigger').attr('aria-expanded', 'true');
        }

        function openSearch() {
            $searchPopover.prop('hidden', false);
            $searchToggle.attr('aria-expanded', 'true');
            setTimeout(function () {
                $searchPopover.find('input[type="search"]').trigger('focus');
            }, 50);
        }

        function closeSearch() {
            $searchPopover.prop('hidden', true);
            $searchToggle.attr('aria-expanded', 'false');
        }

        $triggers.on('click', function (e) {
            e.preventDefault();
            var $item = $(this).closest('.mnhq-mega-item');
            if ($item.hasClass('is-open')) {
                closeAllMega();
            } else {
                openMega($item);
                closeSearch();
            }
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('.mnhq-header').length) {
                closeAllMega();
                closeSearch();
            }
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                closeAllMega();
                closeSearch();
            }
        });

        $searchToggle.on('click', function (e) {
            e.preventDefault();
            if ($searchToggle.attr('aria-expanded') === 'true') {
                closeSearch();
            } else {
                closeAllMega();
                openSearch();
            }
        });

        window.addEventListener('scroll', function () {
            $header.toggleClass('is-scrolled', window.scrollY > 8);
        }, { passive: true });
    });
})(jQuery);
